import { clsx } from 'clsx'
import { AIIcon } from '~/components/icons/ai'

export const AIBadge = ({
  disabled = false,
  className,
  icon = false,
}: {
  disabled?: boolean
  className?: string
  icon?: boolean
}) => {
  return (
    <span
      className={clsx(
        {
          'bg-dark-shade text-dark-faint': disabled,
          'bg-dark-control-base/15 text-dark-control-base': !disabled,
        },
        'px-1 py-1.5 size-5 flex items-center justify-center font-semibold text-xxs rounded',
        className
      )}
    >
      {icon ? <AIIcon style={{ color: 'currentcolor' }} /> : 'AI'}
    </span>
  )
}
